const navThemeControls = {
  methods: {
    setNavThemeChangeOnScroll(theme) {
      const navigation = document.querySelector('#nav-header-pin')

      if (!this.$el || !theme) return

      // change nav bg color when scrolling past Aspot
      this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: '-100% top',
          // end: 'bottom bottom',
          // markers: true,
          onEnter: () => {
            navigation?.firstChild?.classList?.remove(theme)
            navigation?.firstChild?.classList?.add(
              this.$store.state.settings.mainNavStyle
            )
          },
          onLeave: () => {
            navigation?.firstChild?.classList?.remove(
              this.$store.state.settings.mainNavStyle
            )
            navigation?.firstChild?.classList?.add(theme)
          },
          onEnterBack: () => {
            navigation?.firstChild?.classList?.remove(theme)
            navigation?.firstChild?.classList?.add(
              this.$store.state.settings.mainNavStyle
            )
          },
          onLeaveBack: () => {
            navigation?.firstChild?.classList?.remove(
              this.$store.state.settings.mainNavStyle
            )
            navigation?.firstChild?.classList?.add(theme)
          },
        },
      })
    },
  },
}

export { navThemeControls }
